/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Tab_NegotiateInputs */

const en_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiate`)
};

const de_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhandeln`)
};

const fr_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Négocier`)
};

const es_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociar`)
};

const it_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negoziazione`)
};

const nl_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhandelen`)
};

const pl_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negocjacje`)
};

const fi_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuvottelu`)
};

const da_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forhandling`)
};

const sv_salary_tab_negotiate = /** @type {(inputs: Salary_Tab_NegotiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förhandling`)
};

/**
* | output |
* | --- |
* | "Negotiate" |
*
* @param {Salary_Tab_NegotiateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_tab_negotiate = /** @type {((inputs?: Salary_Tab_NegotiateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Tab_NegotiateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_tab_negotiate(inputs)
	if (locale === "fr") return fr_salary_tab_negotiate(inputs)
	if (locale === "es") return es_salary_tab_negotiate(inputs)
	if (locale === "it") return it_salary_tab_negotiate(inputs)
	if (locale === "nl") return nl_salary_tab_negotiate(inputs)
	if (locale === "pl") return pl_salary_tab_negotiate(inputs)
	if (locale === "fi") return fi_salary_tab_negotiate(inputs)
	if (locale === "da") return da_salary_tab_negotiate(inputs)
	if (locale === "sv") return sv_salary_tab_negotiate(inputs)
	return en_salary_tab_negotiate(inputs)
});